import type { InternalAxiosRequestConfig } from 'axios';
import { getCurrentLanguage } from '@protector/utils/i18n';
import { isTrustedDomain } from '../../config/domain.ts';
import type { HeadersParams } from '../http-client.types.ts';
import { getAuthToken } from '../utils/auth.functions.ts';
import { buildHeaders } from '../utils/headers.functions.ts';

export function handleRequest(config: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
  const url = config.baseURL ?? config.url ?? '';

  if (!isTrustedDomain(url)) return config;

  const token = getAuthToken();
  const headers = config.headers as HeadersParams;

  if (token && !headers?.Authorization) {
    const lang = getCurrentLanguage();
    const companyId = sessionStorage.getItem('company_id');

    const builtHeaders = buildHeaders({
      url: config.url ?? '',
      token,
      currentLanguage: lang,
      companyId,
      baseHeaders: headers || {}
    });

    Object.assign(config.headers, builtHeaders);
    config.withCredentials = false;
    return config;
  }

  return config;
}
